import React, { useMemo } from 'react';
import { useGetFleetsInfinite } from '@area-restrita/api-client/endpoints/fleets/fleets.gen';

import { cn } from '@/lib/utils';
import { useDebouncedState } from '@/hooks/useDebounce';
import Combobox, { IComboboxProps, ComboboxOption } from '../Combobox';

type IProps = Omit<IComboboxProps, 'options' | 'onChangeValue'> & {
  onChange?: (option?: ComboboxOption) => void;
};

const FleetSelector: React.FC<IProps> = ({ onChange, className, ...props }) => {
  const [searchValue, setSearchValue, rawSearchValue] =
    useDebouncedState<string>('');

  const query = useGetFleetsInfinite(
    { limit: 100, page: 1, prefix: searchValue },
    {
      query: {
        queryKeyHashFn: (args) => JSON.stringify(['infinite', ...args]),
        getNextPageParam: (lastPage, _, lastPageParam) =>
          lastPage.data.length > 0 ? lastPageParam + 1 : null,
      },
    },
  );

  const fleets = useMemo(
    () =>
      query.data?.pages.flatMap<ComboboxOption>((page) =>
        page.data.map((company) => ({
          label: company.prefix,
          value: company.id,
        })),
      ) ?? [],
    [query.data],
  );

  return (
    <Combobox
      {...(props as IComboboxProps)}
      onChangeValue={onChange}
      options={fleets}
      placeholder="Selecione um prefixo"
      searchPlaceholder="Pesquisar prefixo"
      isLoading={query.isFetching}
      className={cn('w-full', className)}
      showSearch
      searchValue={rawSearchValue}
      onChangeSearchValue={setSearchValue}
    />
  );
};

export default FleetSelector;
